import React, { useContext } from 'react';
import classnames from 'classnames';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isLongTitle } from '../../helpers';
import s from './Title.scss';
var Title = function (_a) {
    var title = _a.title, showTitle = _a.showTitle, className = _a.className;
    var isMobile = useContext(MobileContext);
    if (!title || !showTitle) {
        return isMobile ? null : React.createElement("div", { className: className });
    }
    return (React.createElement("h1", { "data-hook": BiDataHook.DEVIATION_TITLE, className: classnames(s['root'], isLongTitle(title) && s['long'], className) }, title));
};
Title.displayName = 'Title';
export default Title;
//# sourceMappingURL=Title.js.map